export { default } from './BaseInstallInterstitial';

